import { environment } from "../../../environments/environment";

export const EXTENSION_AUTH_REDIRECT_URI_KEY = "extensionAuthRedirectUri";
export const EXTENSION_AUTH_SOURCE_KEY = "extensionAuthSource";

function allowedExtensionIds(): Set<string> {
  const ids = [
    environment.signaturesExtensionId,
    environment.backgroundsExtensionId,
  ]
    .map((id) => (typeof id === "string" ? id.trim().toLowerCase() : ""))
    .filter((id) => /^[a-z0-9]{32}$/.test(id));
  return new Set(ids);
}

export function isValidExtensionRedirectUri(
  value: string | null | undefined,
): boolean {
  if (!value) {
    return false;
  }
  try {
    const url = new URL(value);
    if (url.protocol !== "https:") {
      return false;
    }
    const hostMatch = url.hostname.match(/^([a-z0-9]{32})\.chromiumapp\.org$/i);
    if (!hostMatch) {
      return false;
    }
    return allowedExtensionIds().has(hostMatch[1].toLowerCase());
  } catch {
    return false;
  }
}
